/**
 * Copying text, on pages that are not always secure contexts.
 *
 * `navigator.clipboard` is undefined over plain http, which is exactly how
 * the app is reached in local testing — so the old-style fallback is not
 * legacy cruft, it is the path that runs on a dev box.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Permission refused or an insecure context — fall through and try the
    // selection route rather than failing outright.
  }

  try {
    const area = document.createElement("textarea");
    area.value = text;
    // Off-screen rather than hidden: a display:none element cannot be
    // selected, so the copy would silently do nothing.
    area.style.position = "fixed";
    area.style.opacity = "0";
    area.setAttribute("readonly", "");
    document.body.appendChild(area);
    area.select();
    const copied = document.execCommand("copy");
    document.body.removeChild(area);
    return copied;
  } catch {
    return false;
  }
}
